// Angular modules
import { Component }             from '@angular/core';
import { FormControl }           from '@angular/forms';
import { FormGroup }             from '@angular/forms';
import { FormBuilder }           from '@angular/forms';
import { Validators }            from '@angular/forms';

// Ionic modules
import { GoogleAnalytics }       from '@ionic-native/google-analytics';
import { NavController }         from 'ionic-angular';
import { MenuController }        from 'ionic-angular';
import { ModalController }       from 'ionic-angular';

// External modules
import { VacuumCalculation }     from '../calculator-results/calculation.provider';
import { CalculatorResultsPage } from '../calculator-results/calculator-results';
import { TranslateService }      from '@ngx-translate/core';

// Helpers
import { StorageHelper }         from '../../shared/helpers/storage.helper';

@Component({
  selector    : 'page-compensated-vacuum',
  templateUrl : 'compensated-vacuum.html'
})
export class CompensatedVacuumPage
{
  formGroup   : FormGroup         = null;
  numberRegex : string            = `^([0-9]+([,|\\.][0-9]+)?)$`;
  calculation : VacuumCalculation = new VacuumCalculation();

  constructor
  (
    public  navCtrl    : NavController,
    public  modalCtrl  : ModalController,
    public  translate  : TranslateService,
    public  menuCtrl   : MenuController,
    private builder    : FormBuilder,
    private analytics  : GoogleAnalytics,
  )
  {
    this.getSelectedUnit();
    this.loadFormGroup();
  }

  ionViewDidLoad() { this.analytics.trackView("Compensated result"); }

  toggleMenu() { this.menuCtrl.toggle(); }

  getSelectedUnit()
  {
    this.calculation.unit = StorageHelper.getUnit();
  }

  backAction() { this.navCtrl.pop({animate: false}); }

  public loadFormGroup() : void
  {
    this.formGroup = this.builder.group({
      vacuumChamber : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      packagePerCycle : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      eqCapacity : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      workingHours : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      workingDays : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      workingMonths : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required])
    });
  }

  public onClickSubmit() : void
  {
    let vacuumChamber   : string = null;
    let packagePerCycle : string = null;
    let eqCapacity      : string = null;
    let workingHours    : string = null;
    let workingDays     : string = null;
    let workingMonths   : string = null;

    vacuumChamber   = this.formGroup.controls.vacuumChamber.value.replace(  ',', '.');
    packagePerCycle = this.formGroup.controls.packagePerCycle.value.replace(',', '.');
    eqCapacity      = this.formGroup.controls.eqCapacity.value.replace(     ',', '.');
    workingHours    = this.formGroup.controls.workingHours.value.replace(   ',', '.');
    workingDays     = this.formGroup.controls.workingDays.value.replace(    ',', '.');
    workingMonths   = this.formGroup.controls.workingMonths.value.replace(  ',', '.');

    this.calculation.vacuumChamber   = Number(vacuumChamber);
    this.calculation.packagePerCycle = Number(packagePerCycle);
    this.calculation.eqCapacity      = Number(eqCapacity);
    this.calculation.workingHours    = Number(workingHours);
    this.calculation.workingDays     = Number(workingDays);
    this.calculation.workingMonths   = Number(workingMonths);

    let profileModal = this.modalCtrl.create(CalculatorResultsPage, this.calculation);
    profileModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/compensated-vacuum/compensated-vacuum.ts